<ng-container *ngIf="vm$ | async as vm">
  <!-- <app-invoice-summary [summary]="vm.summary"></app-invoice-summary> -->

  <split-card theme="secondary">
    <ng-container card-header>
      <div class="invoice-toolbar">
        <div class="invoice-toolbar__search">
          <split-search placeholder="Pesquisar nome ou CNPJ..." (valueChange)="onSearch($event)"></split-search>
        </div>
        <div class="invoice-toolbar__actions">
          <split-group-filter
            id="invoiceCardFilter"
            [showClearButton]="false"
            (onFilterEvent)="onFilter($event)">
            <split-filter-dropdown
              groupId="invoiceCardFilter"
              field="status"
              label="Status"
              key="status"
              [data]="statusOptions">
            </split-filter-dropdown>
            <split-filter-professional
              groupId="invoiceCardFilter"
              field="professional"
              label="Prestador"
              key="professional">
            </split-filter-professional>
            <split-filter-date
              groupId="invoiceCardFilter"
              field="revenueDate"
              label="Data"
              key="date"
              initialMode="month"
              [initialDate]="currentMonthDate"
              [emitInitialEvent]="false"
              [showSelectedLabel]="false">
            </split-filter-date>
          </split-group-filter>
          <!--<ng-container *ngIf="exportButtonVm$ | async as exportButtonVm">
            <button
              type="button"
              pButton
              icon="pi pi-download"
              class="invoice-export-button"
              [ngClass]="exportButtonVm.severityClass"
              [loading]="exportButtonVm.exporting"
              [disabled]="exportButtonVm.exporting"
              (click)="onToggleExportPanel($event)">
            </button>
          </ng-container>
          <p-overlayPanel
            #csvExportPanel
            appendTo="body"
            styleClass="invoice-export-panel">
            <ng-container *ngIf="exportPopoverVm$ | async as exportPopoverVm">
              <div class="invoice-export-popover">
                <div class="invoice-export-popover__header">
                  <span class="invoice-export-popover__title">{{ exportPopoverVm.periodLabel }}</span>
                  <span class="invoice-export-popover__meta">Total de notas do mês: {{ exportPopoverVm.monthTotal ?? '-' }}</span>
                </div>

                <div
                  *ngIf="exportPopoverVm.successMessage"
                  class="invoice-export-popover__feedback invoice-export-popover__feedback--success">
                  {{ exportPopoverVm.successMessage }}
                </div>
                <div
                  *ngIf="exportPopoverVm.errorMessage"
                  class="invoice-export-popover__feedback invoice-export-popover__feedback--error">
                  {{ exportPopoverVm.errorMessage }}
                </div>

                <div class="invoice-export-popover__actions">
                  <button
                    type="button"
                    pButton
                    class="p-button-text"
                    label="Cancelar"
                    [disabled]="(exporting$ | async) === true"
                    (click)="csvExportPanel.hide()">
                  </button>
                  <button
                    type="button"
                    pButton
                    icon="pi pi-download"
                    label="Baixar CSV"
                    [loading]="(exporting$ | async) === true"
                    [disabled]="(exporting$ | async) === true"
                    (click)="onConfirmExport()">
                  </button>
                </div>
              </div>
            </ng-container>
          </p-overlayPanel>-->
        </div>
      </div>
    </ng-container>
    <ng-container card-body>
      <ng-container *ngIf="activeFilterChips$ | async as activeFilterChips">
        <split-selected-filters-chips
          [filters]="activeFilterChips"
          [showClearAll]="true"
          (removeFilter)="onRemoveFilter($event)"
          (clearAll)="onClearAllFilters()">
        </split-selected-filters-chips>
      </ng-container>
    </ng-container>
  </split-card>

  <split-loading-placeholder *ngIf="vm.state === 'loading'" [count]="6"></split-loading-placeholder>

  <div *ngIf="vm.state === 'empty'" class="invoice-state">
    <split-icon name="search" size="24"></split-icon>
    <span>Nenhuma nota fiscal encontrada.</span>
  </div>

  <app-invoice-card-list
    *ngIf="vm.state === 'success' || vm.state === 'error'"
    [cards]="vm.cards"
    (actionSelected)="onAction($event)">
  </app-invoice-card-list>

  <split-loading-placeholder *ngIf="vm.loadingMore" [count]="3"></split-loading-placeholder>

  <div *ngIf="vm.state === 'success' || vm.state === 'error'"
       splitInfiniteScroll
       [splitInfiniteScrollDisabled]="!vm.hasMore || vm.loadingMore"
       (scrolled)="onLoadMore()"
       class="invoice-scroll-sentinel">
  </div>

  <app-invoice-revenue-edit-modal
    [invoice]="selectedEditInvoice"
    (success)="onEditModalSuccess()"
    (cancel)="onEditModalCancel()">
  </app-invoice-revenue-edit-modal>
</ng-container>
